import comp from "./LessonPlanningAssistantWrapper";
export default comp;
